export class CategoryLineItems {
    constructor() {
        this.id = null;
        this.name = null;
        this.description = null;
        this.position = null;
        this.items = null;
        this.image = null;
    }

    map(category) {
        if(category.id || category.id === 0) this.id = category.id;

        if (category.name) this.name = category.name;
        else this.name = '';

        if (category.description) this.description = category.description;
        else this.description = '';

        if (category.position >= 0) this.position = category.position;
        else this.position = '';

        if (category.image) this.image = category.image;
        else this.image = null;

        if (category.items) {

            let arrItem = [];
            category.items.map(item => {
                item.category = category.id
                arrItem.push(new LineItem().map(item))
            });

            this.items = arrItem
        } 
        else this.items = [];

        return this;
    }

    update(category) {
        if (category.items) this.items = category.items;

        return this;
      }
}
export class LineItem {
    constructor() {
        this.id = null;
        this.name = null;
        this.description = null;
        this.category = null;
        this.price = null;
        this.image = null;
        this.position = 0;
        this.imageFile = null;
        this.imagePreview = null;    
        this.selected = false;
    }

    map(lineItem) {
        if(lineItem.id || lineItem === 0) this.id = lineItem.id;

        if (lineItem.name) this.name = lineItem.name;
        else this.name = '';

        if (lineItem.description) this.description = lineItem.description;
        else this.description = '';

        if (lineItem.category) this.category = lineItem.category;
        else this.category = '';

        if (lineItem.price) this.price = lineItem.price;
        else this.price = '';

        if (lineItem.position >= 0) this.position = lineItem.position;
        else this.position = 0;

        if (lineItem.image) this.image = lineItem.image;
        else this.image = '';

        return this;
    }

    update(lineItem) {
        if (lineItem.id) this.id = lineItem.id;
        if (lineItem.name) this.name = lineItem.name;
        if (lineItem.description) this.description = lineItem.description;
        if (lineItem.category) this.category = lineItem.category;
        if (lineItem.price) this.price = lineItem.price;
        if (category.position) this.position = category.position;
        if (lineItem.imageFile) this.imageFile = lineItem.imageFile;
        if (lineItem.imagePreview) this.imagePreview = lineItem.imagePreview;

        return this;
      }

      uploadImage(data) {
        this.imageFile = data.file;
        this.imagePreview = data.preview;

        return this;
    }
}